import Intro from "./intro";
import ScrollFunc from "./scrollfunc";
import Canvas from "./mv/canvas";
import Swiper, { Pagination, Autoplay } from "swiper";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.acc();
        this.setMVInnerHeight();
        this.swiper();

        //instances
        this.intro = new Intro();
        this.ScrollFunc = new ScrollFunc();
        this.canvas = new Canvas();
    }

    acc() {
        const $trigger = document.querySelectorAll(".js-acc__trigger");

        [...$trigger].forEach((el) => {
            const container = el.nextElementSibling;

            el.addEventListener("click", () => {
                container.classList.toggle("-acc_active");
                el.classList.toggle("-acc_active");
            });
        });
    }

    setMVInnerHeight() {
        //100vhの技をスマホで使うとツールバーの高さで上手く行かないため、css variablesで対応。。
        const inner = document.querySelector(".mainvisual__inner");
        inner.style.setProperty("--height", window.innerHeight - window.innerWidth * 0.16 + "px");
    }

    swiper() {
        Swiper.use([Pagination, Autoplay]);
        const swiper = new Swiper(".swiper-container", {
            // Optional parameters
            loop: true,
            speed: 1000,
            autoplay: {
                delay: 5000,
            },

            // If we need pagination
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
        });
    }
}
